<template>
  <div>
    <app-nav :full-name="userFullName" />

    <div class="columns">
      <div class="column"/>
      <div class="column is-three-quarters">

        <!-- optional metedata if existing fabric -->
        <div
          v-if="displayMetadata"
          class="content is-small">
          <div>Created by: {{ fabric.createdBy }}</div>
          <div>Created on: {{ format(fabric.createdOn) }}</div>
          <div>Last updated by: {{ fabric.lastUpdatedBy }}</div>
          <div>Last updated: {{ format(fabric.lastUpdated) }}</div>
          <hr>
        </div>

        <!-- fabric form, should be populated with data if existing fabric -->

        <section class="section">
          <div class="container">
            <h2 class="title">ARTICLE INFORMATION</h2>
          </div>
        </section>

        <div class="field">
          <label class="label">1. Article Name/Number <span class="required-field">*</span></label>
          <div class="control">
            <input
              id="articleId"
              v-model="articleId"
              autofocus
              class="input"
              type="text"
              name="articleId">
          </div>
        </div>

        <div class="field">
          <label class="label">2. Article Description <span class="required-field">*</span></label>
          <div class="control">
            <input
              id="articleDescription"
              v-model="articleDescription"
              class="input"
              type="text"
              name="articleDescription">
          </div>
        </div>

        <div class="field">
          <label class="label">3. Is this article a woven or cut & sewn knit fabric? <span class="required-field">*</span></label>
          <div class="control">
            <div class="select">
              <select
                id="wovenOrCutSewnKnit"
                v-model="wovenOrCutSewnKnitSelect"
                name="wovenOrCutSewnKnit">
                <option value="">Please Select ...</option>
                <option value="w">Woven</option>
                <option value="c">Cut & Sew Knit</option>
              </select>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">
            4. What is the fiber content of the finished fabric? <span class="required-field">*</span>
            <div class="label-description">
              Please format your response as follows: fiber percentage followed by fiber code. For example, fabric that is 55% Organic Cotton, 35% linen,
              and 10% Elastane should be written as: 55ORG CO 35LI 10EA.
            </div>
          </label>
          <div class="control">
            <input
              id="fiberContent"
              v-model="fiberContent"
              class="input"
              type="text"
              name="fiberContent">
          </div>
        </div>

        <div class="field">
          <label class="label">5. HS Code</label>
          <div class="control">
            <input
              id="hsCode"
              v-model="hsCode"
              class="input"
              type="text"
              name="hsCode">
          </div>
        </div>

        <div class="field">
          <label class="label">6. Bulk Lead Time (weeks) <span class="required-field">*</span></label>
          <div class="control">
            <input
              id="bulkLeadTime"
              v-model="bulkLeadTime"
              class="input"
              type="text"
              name="bulkLeadTime">
          </div>
        </div>

        <div class="field">
          <label class="label">7. Bulk Minimum <span class="required-field">*</span></label>
          <div class="control">
            <input
              id="bulkMinimum"
              v-model="bulkMinimum"
              class="input"
              type="text"
              name="bulkMinimum">
          </div>
        </div>

        <div class="field">
          <label class="label">8. Sample Lead Time (weeks) <span class="required-field">*</span></label>
          <div class="control">
            <input
              id="sampleLeadTime"
              v-model="sampleLeadTime"
              class="input"
              type="text"
              name="sampleLeadTime">
          </div>
        </div>

        <div class="field">
          <label class="label">
            9. Sample Minimum <span class="required-field">*</span>
            <div class="label-description">
              Specify the minimum quantity by ORDER and COLOR. Ensure to include the unit of measure for each.
            </div>
          </label>
          <div class="control">
            <input
              id="sampleMinimum"
              v-model="sampleMinimum"
              class="input"
              type="text"
              name="sampleMinimum">
          </div>
        </div>

        <div class="field">
          <label class="label">10. Price Term <span class="required-field">*</span></label>
          <div class="control">
            <div class="select">
              <select
                id="priceTerm"
                v-model="priceTermSelect"
                name="priceTerm">
                <option value="">Please Select ...</option>
                <option value="f">FOB/FCA</option>
                <option value="e">EXW</option>
              </select>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">
            11. Bulk Price <span class="required-field">*</span>
            <div class="label-description">
              Provide bulk fabric price in USD. Unit of measure must be specified, e.g. meters, yards.
            </div>
          </label>
          <div class="control">
            <input
              id="bulkPrice"
              v-model="bulkPrice"
              class="input"
              type="text"
              name="bulkPrice">
          </div>
        </div>

        <div class="field">
          <label class="label">
            12. Sample Price <span class="required-field">*</span>
            <div class="label-description">
              Provide sample fabric price in USD. Unit of measure must be specified. Specify surcharge separately, if applicable.
            </div>
          </label>
          <div class="control">
            <input
              id="samplePrice"
              v-model="samplePrice"
              class="input"
              type="text"
              name="samplePrice">
          </div>
        </div>

        <div class="field">
          <label class="label">13. Full Width <span class="required-field">*</span></label>
          <div class="control">
            <input
              id="fullWidth"
              v-model="fullWidth"
              class="input"
              type="text"
              name="fullWidth">
          </div>
        </div>

        <div class="field">
          <label class="label">14. Full Width Unit <span class="required-field">*</span></label>
          <div class="control">
            <div class="select">
              <select
                id="fullWidthUnit"
                v-model="fullWidthUnitSelect"
                name="fullWidthUnit">
                <option value="">Please Select ...</option>
                <option value="i">Inches</option>
                <option value="c">Centimeters</option>
              </select>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">15. Cuttable Width <span class="required-field">*</span></label>
          <div class="control">
            <input
              id="cuttableWidth"
              v-model="cuttableWidth"
              class="input"
              type="text"
              name="cuttableWidth">
          </div>
        </div>

        <div class="field">
          <label class="label">16. Cuttable Width Unit <span class="required-field">*</span></label>
          <div class="control">
            <div class="select">
              <select
                id="cuttableWidthUnit"
                v-model="cuttableWidthUnitSelect"
                name="cuttableWidthUnit">
                <option value="">Please Select ...</option>
                <option value="i">Inches</option>
                <option value="c">Centimeters</option>
              </select>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">17. Fabric Construction <span class="required-field">*</span></label>
          <div class="control">
            <input
              id="fabricConstruction"
              v-model="fabricConstruction"
              class="input"
              type="text"
              name="fabricConstruction">
          </div>
        </div>

        <div class="field">
          <label class="label">18. Weight <span class="required-field">*</span></label>
          <div class="control">
            <input
              id="weight"
              v-model="weight"
              class="input"
              type="text"
              name="weight">
          </div>
        </div>

        <div class="field">
          <label class="label">19. Piece Length <span class="required-field">*</span></label>
          <div class="control">
            <input
              id="pieceLength"
              v-model="pieceLength"
              class="input"
              type="text"
              name="pieceLength">
          </div>
        </div>

        <div class="field">
          <label class="label">20. Piece Length Unit <span class="required-field">*</span></label>
          <div class="control">
            <div class="select">
              <select
                id="pieceLengthUnit"
                v-model="pieceLengthUnitSelect"
                name="pieceLengthUnit">
                <option value="">Please Select ...</option>
                <option value="y">Yards</option>
                <option value="m">Meters</option>
              </select>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">21. Shrinkage <span class="required-field">*</span></label>
          <div class="control">
            <input
              id="shrinkage"
              v-model="shrinkage"
              class="input"
              type="text"
              name="shrinkage">
          </div>
        </div>

        <div class="field">
          <label class="label">22. Does this article contain animal fiber? <span class="required-field">*</span></label>
          <div class="control">
            <div class="select">
              <select
                id="containAnimalFiber"
                v-model="containAnimalFiberSelect"
                name="containAnimalFiber">
                <option value="">Please Select ...</option>
                <option value="y">Yes</option>
                <option value="n">No</option>
              </select>
            </div>
          </div>
        </div>

        <div :class="'field followup ' + animalFiberFollowup">
          <label class="label">22a. Advise the animal's scientific name (genus and species)</label>
          <div class="control">
            <input
              id="animalScientificName"
              v-model="animalScientificName"
              class="input"
              type="text"
              name="animalScientificName">
          </div>
        </div>

        <div class="field">
          <label class="label">23. Does this article contain organic fiber? <span class="required-field">*</span></label>
          <div class="control">
            <div class="select">
              <select
                id="containOrganicFiber"
                v-model="containOrganicFiberSelect"
                name="containOrganicFiber">
                <option value="">Please Select ...</option>
                <option value="y">Yes</option>
                <option value="n">No</option>
              </select>
            </div>
          </div>
        </div>

        <div :class="'field followup ' + organicFiberFollowup">
          <label class="label">
            23a. Upload organic fiber supplier's Scope Certificate
            <div class="label-description">
              A Scope Certificate is a facility-based certificate to show that a supplier has been audited and certified to
              process organic or recycled materials. A Scope Certificate does not require a purchase or order.
            </div>
          </label>
          <div class="control">
            <vue-clip
              :options="fileUploadOptions"
              :on-added-file="onAddedFile"
              :on-complete="onOrganicFiberCertificateUploadComplete"
              :on-sending="onStartUploadingOrganicCertificate">
              <template slot="clip-uploader-action">
                <div>
                  <div class="dz-message button is-light">
                    <span class="icon">
                      <i class="fas fa-upload" />
                    </span>
                    <span>Select a file to upload</span>
                  </div>
                </div>
              </template>
            </vue-clip>
          </div>
          <uploaded-file :filename="uploadedOrganicFiberCertificate" />
        </div>

        <div :class="'field followup ' + organicFiberFollowup">
          <label class="label">23b. Upload additional documents if necessary</label>
          <div class="control">
            <vue-clip
              :options="fileUploadOptions"
              :on-added-file="onAddedFile"
              :on-complete="onOrganicFiberAdditionalDocumentUploadComplete"
              :on-sending="onStartUploadingOrganicAdditionalDocument">
              <template slot="clip-uploader-action">
                <div>
                  <div class="dz-message button is-light">
                    <span class="icon">
                      <i class="fas fa-upload" />
                    </span>
                    <span>Select a file to upload</span>
                  </div>
                </div>
              </template>
            </vue-clip>
          </div>
          <uploaded-file :filename="uploadedOrganicFiberAdditionalDocument" />
        </div>

        <div class="field">
          <label class="label">24. Does this article contain recycled fiber? <span class="required-field">*</span></label>
          <div class="control">
            <div class="select">
              <select
                id="containRecycledFiber"
                v-model="containRecycledFiberSelect"
                name="containRecycledFiber">
                <option value="">Please Select ...</option>
                <option value="y">Yes</option>
                <option value="n">No</option>
              </select>
            </div>
          </div>
        </div>

        <div :class="'field followup ' + recycledFiberFollowup">
          <label class="label">
            24a. Upload Recycled fiber supplier's Scope Certificate
            <div class="label-description">
              A Scope Certificate is a facility-based certificate to show that a supplier has been audited and certified to
              process organic or recycled materials. A Scope Certificate does not require a purchase or order.
            </div>
          </label>
          <div class="control">
            <vue-clip
              :options="fileUploadOptions"
              :on-added-file="onAddedFile"
              :on-complete="onRecycledFiberCertificateUploadComplete"
              :on-sending="onStartUploadingRecycledCertificate">
              <template slot="clip-uploader-action">
                <div>
                  <div class="dz-message button is-light">
                    <span class="icon">
                      <i class="fas fa-upload" />
                    </span>
                    <span>Select a file to upload</span>
                  </div>
                </div>
              </template>
            </vue-clip>
          </div>
          <uploaded-file :filename="uploadedRecycledFiberCertificate" />
        </div>

        <div :class="'field followup ' + recycledFiberFollowup">
          <label class="label">24b. Upload additional documents if necessary</label>
          <div class="control">
            <vue-clip
              :options="fileUploadOptions"
              :on-added-file="onAddedFile"
              :on-complete="onRecycledFiberAdditionalDocumentUploadComplete"
              :on-sending="onStartUploadingRecycledAdditionalDocument">
              <template slot="clip-uploader-action">
                <div>
                  <div class="dz-message button is-light">
                    <span class="icon">
                      <i class="fas fa-upload" />
                    </span>
                    <span>Select a file to upload</span>
                  </div>
                </div>
              </template>
            </vue-clip>
          </div>
          <uploaded-file :filename="uploadedRecycledFiberAdditionalDocument" />
        </div>

        <div class="field">
          <label class="label">25. Recommended Care Instructions <span class="required-field">*</span></label>
          <div class="control">
            <textarea
              id="careInstruction"
              v-model="careInstruction"
              class="textarea"
              type="text"
              name="careInstruction"/>
          </div>
        </div>

        <section class="section">
          <div class="container">
            <h2 class="title">FABRIC MILL INFORMATION</h2>
          </div>
        </section>

        <div class="field">
          <label class="label">26. Fabric Mill Name <span class="required-field">*</span></label>
          <div class="control">
            <input
              id="millName"
              v-model="millName"
              class="input"
              type="text"
              name="millName">
          </div>
        </div>

        <div class="field">
          <label class="label">27. Fabric Mill Address <span class="required-field">*</span></label>
          <div class="control">
            <input
              id="millAddress"
              v-model="millAddress"
              class="input"
              type="text"
              name="millAddress">
          </div>
        </div>

        <div class="field">
          <label class="label">28. Fabric Mill Country <span class="required-field">*</span></label>
          <div class="control">
            <div class="select">
              <select
                id="millCountry"
                v-model="millCountrySelect"
                name="element">
                <option
                  v-for="(item, key) in countries"
                  :key="key"
                  :value="key">{{ item }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="field">
          <label class="label">
            29. Is knitting or weaving of this fabric performed by a company other than the Fabric Mill listed above?
            <span class="required-field">*</span>
          </label>
          <div class="control">
            <div class="select">
              <select
                id="performedByOtherCompany"
                v-model="performedByOtherCompanySelect"
                name="performedByOtherCompany">
                <option value="">Please Select ...</option>
                <option value="y">Yes</option>
                <option value="n">No</option>
              </select>
            </div>
          </div>
        </div>

        <div :class="'field followup ' + performedByOtherCompanyFollowup">
          <label class="label">29a. Knitter/Weaver Name</label>
          <div class="control">
            <input
              id="knitterWeaverName"
              v-model="knitterWeaverName"
              class="input"
              type="text"
              name="knitterWeaverName">
          </div>
        </div>

        <div :class="'field followup ' + performedByOtherCompanyFollowup">
          <label class="label">29b. Knitter/Weaver Address</label>
          <div class="control">
            <input
              id="knitterWeaverAddress"
              v-model="knitterWeaverAddress"
              class="input"
              type="text"
              name="knitterWeaverAddress">
          </div>
        </div>

        <div class="field is-grouped">
          <div class="control">
            <button
              class="button is-link"
              @click="saveFabric">Save</button>
          </div>
          <div class="control">
            <router-link
              class="button is-danger is-outlined"
              to="/">Cancel</router-link>
          </div>
        </div>

      </div>
      <div class="column"/>
    </div>

    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="true" />
  </div>
</template>

<script>
import AppNav from './AppNav'
import UploadedFile from './UploadedFile'
import { checkLogin, getUser } from '../utils/auth'
import { format } from '../utils/datetime'
import { getFabric, saveFabric } from '../utils/rfi'

export default {
  name: 'fabric',
  components: {
    AppNav,
    UploadedFile
  },
  data() {
    return {
      fabric: '',
      userFullName: '',
      // loading
      isLoading: false,
      // input values
      articleId: '',
      articleDescription: '',
      fiberContent: '',
      hsCode: '',
      bulkLeadTime: '',
      bulkMinimum: '',
      sampleLeadTime: '',
      sampleMinimum: '',
      bulkPrice: '',
      samplePrice: '',
      fullWidth: '',
      cuttableWidth: '',
      fabricConstruction: '',
      weight: '',
      pieceLength: '',
      shrinkage: '',
      animalScientificName: '',
      careInstruction: '',
      millName: '',
      millAddress: '',
      knitterWeaverName: '',
      knitterWeaverAddress: '',
      // select values
      wovenOrCutSewnKnitSelect: '',
      priceTermSelect: '',
      fullWidthUnitSelect: '',
      cuttableWidthUnitSelect: '',
      pieceLengthUnitSelect: '',
      containAnimalFiberSelect: '',
      containOrganicFiberSelect: '',
      containRecycledFiberSelect: '',
      millCountrySelect: '',
      performedByOtherCompanySelect: '',
      // uploaded file names
      uploadedOrganicFiberCertificate: '',
      uploadedOrganicFiberAdditionalDocument: '',
      uploadedRecycledFiberCertificate: '',
      uploadedRecycledFiberAdditionalDocument: '',
      // countries
      countries: {
        '': 'Please Select',
        'US': 'United States',
        'GB': 'United Kingdom',
        'DE': 'Germany',
        'BR': 'Brazil',
        'IT': 'Italy',
        'ES': 'Spain',
        'AU': 'Australia',
        'FR': 'France',
        'CN': 'China',
        '--': '----------',
        'AF': 'Afghanistan',
        'AL': 'Albania',
        'DZ': 'Algeria',
        'AD': 'Andorra',
        'AO': 'Angola',
        'AI': 'Anguilla',
        'AG': 'Antigua and Barbuda',
        'AR': 'Argentina',
        'AM': 'Armenia',
        'AT': 'Austria',
        'AZ': 'Azerbaijan',
        'BS': 'Bahamas',
        'BH': 'Bahrain',
        'BD': 'Bangladesh',
        'BB': 'Barbados',
        'BY': 'Belarus',
        'BE': 'Belgium',
        'BZ': 'Belize',
        'BJ': 'Benin',
        'BM': 'Bermuda',
        'BT': 'Bhutan',
        'BO': 'Bolivia',
        'BA': 'Bosnia and Herzegovina',
        'BW': 'Botswana',
        'BN': 'Brunei Darussalam',
        'BG': 'Bulgaria',
        'BF': 'Burkina Faso',
        'BI': 'Burundi',
        'KH': 'Cambodia',
        'CM': 'Cameroon',
        'CA': 'Canada',
        'CV': 'Cape Verde',
        'KY': 'Cayman Islands',
        'CF': 'Central African Republic',
        'TD': 'Chad',
        'CL': 'Chile',
        'CO': 'Colombia',
        'KM': 'Comoros',
        'CG': 'Congo',
        'CR': 'Costa Rica',
        'HR': 'Croatia (Hrvatska)',
        'CU': 'Cuba',
        'CY': 'Cyprus',
        'CZ': 'Czech Republic',
        'DK': 'Denmark',
        'DJ': 'Djibouti',
        'DM': 'Dominica',
        'DO': 'Dominican Republic',
        'EC': 'Ecuador',
        'EG': 'Egypt',
        'SV': 'El Salvador',
        'GQ': 'Equatorial Guinea',
        'ER': 'Eritrea',
        'EE': 'Estonia',
        'ET': 'Ethiopia',
        'FO': 'Faroe Islands',
        'FJ': 'Fiji',
        'FI': 'Finland',
        'GF': 'French Guiana',
        'PF': 'French Polynesia',
        'TF': 'French Southern Territories',
        'GA': 'Gabon',
        'GM': 'Gambia',
        'GE': 'Georgia',
        'GH': 'Ghana',
        'GR': 'Greece',
        'GL': 'Greenland',
        'GD': 'Grenada',
        'GP': 'Guadeloupe',
        'GU': 'Guam',
        'GT': 'Guatemala',
        'GN': 'Guinea',
        'GW': 'Guinea-Bissau',
        'GY': 'Guyana',
        'HT': 'Haiti',
        'HN': 'Honduras',
        'HK': 'Hong Kong',
        'HU': 'Hungary',
        'IS': 'Iceland',
        'IN': 'India',
        'IM': 'Isle of Man',
        'ID': 'Indonesia',
        'IR': 'Iran',
        'IQ': 'Iraq',
        'IE': 'Ireland',
        'IL': 'Israel',
        'CI': 'Ivory Coast',
        'JE': 'Jersey',
        'JM': 'Jamaica',
        'JP': 'Japan',
        'JO': 'Jordan',
        'KZ': 'Kazakhstan',
        'KE': 'Kenya',
        'KI': 'Kiribati',
        'KP': 'North Korea',
        'KR': 'South Korea',
        'XK': 'Kosovo',
        'KW': 'Kuwait',
        'KG': 'Kyrgyzstan',
        'LA': 'Lao',
        'LV': 'Latvia',
        'LB': 'Lebanon',
        'LS': 'Lesotho',
        'LR': 'Liberia',
        'LY': 'Libyan Arab Jamahiriya',
        'LI': 'Liechtenstein',
        'LT': 'Lithuania',
        'LU': 'Luxembourg',
        'MK': 'Macedonia',
        'MG': 'Madagascar',
        'MW': 'Malawi',
        'MY': 'Malaysia',
        'MV': 'Maldives',
        'ML': 'Mali',
        'MT': 'Malta',
        'MH': 'Marshall Islands',
        'MQ': 'Martinique',
        'MR': 'Mauritania',
        'MU': 'Mauritius',
        'MX': 'Mexico',
        'FM': 'Micronesia, Federated States of',
        'MD': 'Moldova, Republic of',
        'MC': 'Monaco',
        'MN': 'Mongolia',
        'ME': 'Montenegro',
        'MS': 'Montserrat',
        'MA': 'Morocco',
        'MZ': 'Mozambique',
        'MM': 'Myanmar',
        'NA': 'Namibia',
        'NR': 'Nauru',
        'NP': 'Nepal',
        'NL': 'Netherlands',
        'AN': 'Netherlands Antilles',
        'NC': 'New Caledonia',
        'NZ': 'New Zealand',
        'NI': 'Nicaragua',
        'NE': 'Niger',
        'NG': 'Nigeria',
        'MP': 'Northern Mariana Islands',
        'NO': 'Norway',
        'OM': 'Oman',
        'PK': 'Pakistan',
        'PW': 'Palau',
        'PS': 'Palestine',
        'PA': 'Panama',
        'PG': 'Papua New Guinea',
        'PY': 'Paraguay',
        'PE': 'Peru',
        'PH': 'Philippines',
        'PL': 'Poland',
        'PT': 'Portugal',
        'PR': 'Puerto Rico',
        'QA': 'Qatar',
        'RE': 'Reunion',
        'RO': 'Romania',
        'RU': 'Russian Federation',
        'RW': 'Rwanda',
        'KN': 'Saint Kitts and Nevis',
        'LC': 'Saint Lucia',
        'VC': 'Saint Vincent and the Grenadines',
        'WS': 'Samoa',
        'SM': 'San Marino',
        'ST': 'Sao Tome and Principe',
        'SA': 'Saudi Arabia',
        'SN': 'Senegal',
        'RS': 'Serbia',
        'SC': 'Seychelles',
        'SL': 'Sierra Leone',
        'SG': 'Singapore',
        'SK': 'Slovakia',
        'SI': 'Slovenia',
        'SB': 'Solomon Islands',
        'SO': 'Somalia',
        'ZA': 'South Africa',
        'LK': 'Sri Lanka',
        'SH': 'St. Helena',
        'PM': 'St. Pierre and Miquelon',
        'SD': 'Sudan',
        'SR': 'Suriname',
        'SJ': 'Svalbard and Jan Mayen Islands',
        'SZ': 'Swaziland',
        'SE': 'Sweden',
        'CH': 'Switzerland',
        'SY': 'Syrian Arab Republic',
        'TW': 'Taiwan',
        'TJ': 'Tajikistan',
        'TZ': 'Tanzania',
        'TH': 'Thailand',
        'TG': 'Togo',
        'TK': 'Tokelau',
        'TO': 'Tonga',
        'TT': 'Trinidad and Tobago',
        'TN': 'Tunisia',
        'TR': 'Turkey',
        'TM': 'Turkmenistan',
        'TV': 'Tuvalu',
        'UG': 'Uganda',
        'UA': 'Ukraine',
        'AE': 'United Arab Emirates',
        'UM': 'United States minor outlying islands',
        'UY': 'Uruguay',
        'UZ': 'Uzbekistan',
        'VU': 'Vanuatu',
        'VE': 'Venezuela',
        'VN': 'Vietnam',
        'VI': 'Virgin Islands (U.S.)',
        'WF': 'Wallis and Futuna Islands',
        'YE': 'Yemen',
        'ZM': 'Zambia',
        'ZW': 'Zimbabwe'
      }
    }
  },
  computed: {
    millCountry: function() {
      if (this.fabric.millCountry !== undefined) {
        return this.fabric.millCountry
      }
      return ''
    },
    displayMetadata: function() {
      return this.fabric !== undefined && this.fabric !== ''
    },
    // classes
    animalFiberFollowup: function() {
      if (this.containAnimalFiberSelect === 'y') {
        return ''
      } else {
        return 'is-hidden'
      }
    },
    organicFiberFollowup: function() {
      if (this.containOrganicFiberSelect === 'y') {
        return ''
      } else {
        return 'is-hidden'
      }
    },
    recycledFiberFollowup: function() {
      if (this.containRecycledFiberSelect === 'y') {
        return ''
      } else {
        return 'is-hidden'
      }
    },
    performedByOtherCompanyFollowup: function() {
      if (this.performedByOtherCompanySelect === 'y') {
        return ''
      } else {
        return 'is-hidden'
      }
    },
    fileUploadOptions: function() {
      let token = JSON.parse(getUser()).token
      let authorization = 'Bearer ' + token
      return {
        url: 'https://api-rfi.tianenusa.com/files',
        paramName: 'file',
        headers: {
          'Authorization': authorization
        }
      }
    }
  },
  mounted() {
    let self = this
    checkLogin().then(function(loggedIn) {
      if (loggedIn) {
        self.getFabric()
        self.userFullName = JSON.parse(getUser()).fullName
      } else {
        self.$router.push('/login')
      }
    })
  },
  methods: {
    getFabric() {
      let self = this
      if (this.$route.params.articleId !== undefined) {
        self.isLoading = true
        let articleIdParam = this.$route.params.articleId
        getFabric(articleIdParam).then((fabric) => {
          self.fabric = fabric
          // populate input values
          self.articleId = self.fabric.articleId
          self.articleDescription = self.fabric.articleDescription
          self.fiberContent = self.fabric.fiberContent
          self.hsCode = self.fabric.hsCode
          self.bulkLeadTime = self.fabric.bulkLeadTime.toString()
          self.bulkMinimum = self.fabric.bulkMinimum
          self.sampleLeadTime = self.fabric.sampleLeadTime.toString()
          self.sampleMinimum = self.fabric.sampleMinimum
          self.bulkPrice = self.fabric.bulkPrice
          self.samplePrice = self.fabric.samplePrice
          self.fullWidth = self.fabric.fullWidth.toString()
          self.cuttableWidth = self.fabric.cuttableWidth.toString()
          self.fabricConstruction = self.fabric.fabricConstruction
          self.weight = self.fabric.weight.toString()
          self.pieceLength = self.fabric.pieceLength.toString()
          self.shrinkage = self.fabric.shrinkage
          self.animalScientificName = self.fabric.animalScientificName
          self.careInstruction = self.fabric.careInstruction
          self.millName = self.fabric.millName
          self.millAddress = self.fabric.millAddress
          self.knitterWeaverName = self.fabric.knitterWeaverName
          self.knitterWeaverAddress = self.fabric.knitterWeaverAddress
          // populate selected options
          self.wovenOrCutSewnKnitSelect = self.fabric.wovenOrCutSewnKnit
          self.priceTermSelect = self.fabric.priceTerm
          self.fullWidthUnitSelect = self.fabric.fullWidthUnit
          self.cuttableWidthUnitSelect = self.fabric.cuttableWidthUnit
          self.pieceLengthUnitSelect = self.fabric.pieceLengthUnit
          self.containAnimalFiberSelect = self.fabric.containAnimalFiber
          self.containOrganicFiberSelect = self.fabric.containOrganicFiber
          self.containRecycledFiberSelect = self.fabric.containRecycledFiber
          self.millCountrySelect = self.fabric.millCountry
          self.performedByOtherCompanySelect = self.fabric.performedByOtherCompany
          // uploaded files
          self.uploadedOrganicFiberCertificate = self.fabric.organicFiberCertificate
          self.uploadedOrganicFiberAdditionalDocument = self.fabric.organicFiberAdditionalDocument
          self.uploadedRecycledFiberCertificate = self.fabric.recycledFiberCertificate
          self.uploadedRecycledFiberAdditionalDocument = self.fabric.recycledFiberAdditionalDocument
        }).finally(function() {
          self.isLoading = false
        })
      }
    },
    format(timestamp) {
      return format(timestamp)
    },
    // file added listener
    onAddedFile(file) {
      if (this.articleId === '') {
        this.$toast.open({
          message: 'Please provide the Article ID first at the beginning of the form.',
          duration: 5000,
          position: 'is-top',
          type: 'is-danger'
        })
        this.files = []
      }
    },
    // start uploading event listeners
    onStartUploadingOrganicCertificate(file, xhr, formData) {
      formData.append('articleId', this.articleId)
      formData.append('purpose', 'organic-certificate')
    },
    onStartUploadingOrganicAdditionalDocument(file, xhr, formData) {
      formData.append('articleId', this.articleId)
      formData.append('purpose', 'organic-additional-document')
    },
    onStartUploadingRecycledCertificate(file, xhr, formData) {
      formData.append('articleId', this.articleId)
      formData.append('purpose', 'recycled-certificate')
    },
    onStartUploadingRecycledAdditionalDocument(file, xhr, formData) {
      formData.append('articleId', this.articleId)
      formData.append('purpose', 'recycled-additional-document')
    },
    // upload complete event listeners
    onOrganicFiberCertificateUploadComplete(file, status, xhr) {
      if (status === 'success') {
        this.$toast.open({
          message: 'Organic fiber certificate was uploaded successfully.',
          duration: 5000,
          position: 'is-top',
          type: 'is-success',
          queue: false
        })
        this.uploadedOrganicFiberCertificate = xhr.responseText
      } else {
        this.$toast.open({
          message: `Organic fiber certificate upload failed. ${xhr.responseText}`,
          duration: 5000,
          position: 'is-top',
          type: 'is-danger',
          queue: false
        })
      }
    },
    onOrganicFiberAdditionalDocumentUploadComplete(file, status, xhr) {
      if (status === 'success') {
        this.$toast.open({
          message: 'Organic fiber additional document was uploaded successfully.',
          duration: 5000,
          position: 'is-top',
          type: 'is-success',
          queue: false
        })
        this.uploadedOrganicFiberAdditionalDocument = xhr.responseText
      } else {
        this.$toast.open({
          message: `Organic fiber additional document upload failed. ${xhr.responseText}`,
          duration: 5000,
          position: 'is-top',
          type: 'is-danger',
          queue: false
        })
      }
    },
    onRecycledFiberCertificateUploadComplete(file, status, xhr) {
      if (status === 'success') {
        this.$toast.open({
          message: 'Recycled fiber certificate was uploaded successfully.',
          duration: 5000,
          position: 'is-top',
          type: 'is-success',
          queue: false
        })
        this.uploadedRecycledFiberCertificate = xhr.responseText
      } else {
        this.$toast.open({
          message: `Recycled fiber certificate upload failed. ${xhr.responseText}`,
          duration: 5000,
          position: 'is-top',
          type: 'is-danger',
          queue: false
        })
      }
    },
    onRecycledFiberAdditionalDocumentUploadComplete(file, status, xhr) {
      if (status === 'success') {
        this.$toast.open({
          message: 'Recycled fiber additional document was uploaded successfully.',
          duration: 5000,
          position: 'is-top',
          type: 'is-success',
          queue: false
        })
        this.uploadedRecycledFiberAdditionalDocument = xhr.responseText
      } else {
        this.$toast.open({
          message: `Recycled fiber additional document upload failed. ${xhr.responseText}`,
          duration: 5000,
          position: 'is-top',
          type: 'is-danger',
          queue: false
        })
      }
    },
    saveFabric() {
      let self = this
      let fabric = {
        articleId: this.articleId,
        articleDescription: this.articleDescription,
        wovenOrCutSewnKnit: this.wovenOrCutSewnKnitSelect,
        fiberContent: this.fiberContent,
        hsCode: this.hsCode,
        bulkLeadTime: parseInt(this.bulkLeadTime),
        bulkMinimum: this.bulkMinimum,
        sampleLeadTime: parseInt(this.sampleLeadTime),
        sampleMinimum: this.sampleMinimum,
        priceTerm: this.priceTermSelect,
        bulkPrice: this.bulkPrice,
        samplePrice: this.samplePrice,
        fullWidth: parseInt(this.fullWidth),
        fullWidthUnit: this.fullWidthUnit,
        cuttableWidth: parseInt(this.cuttableWidth),
        cuttableWidthUnit: this.cuttableWidthUnit,
        fabricConstruction: this.fabricConstruction,
        weight: parseInt(this.weight),
        pieceLength: parseInt(this.pieceLength),
        pieceLengthUnit: this.pieceLengthUnit,
        shrinkage: this.shrinkage,
        containAnimalFiber: this.containAnimalFiberSelect,
        animalScientificName: this.animalScientificName,
        containOrganicFiber: this.containOrganicFiberSelect,
        organicFiberCertificate: this.uploadedOrganicFiberCertificate,
        organicFiberAdditionalDocument: this.uploadedOrganicFiberAdditionalDocument,
        containRecycledFiber: this.containRecycledFiberSelect,
        recycledFiberCertificate: this.uploadedRecycledFiberCertificate,
        recycledFiberAdditionalDocument: this.uploadedRecycledFiberAdditionalDocument,
        careInstruction: this.careInstruction,
        millName: this.millName,
        millAddress: this.millAddress,
        millCountry: this.millCountrySelect,
        performedByOtherCompany: this.performedByOtherCompanySelect,
        knitterWeaverName: this.knitterWeaverName,
        knitterWeaverAddress: this.knitterWeaverAddress,
        createdBy: this.fabric.createdBy || '',
        createdOn: this.fabric.createdOn || 0,
        lastUpdatedBy: this.fabric.lastUpdatedBy || '',
        lastUpdated: this.fabric.lastUpdated || 0
      }
      let existingFabric = (self.fabric !== undefined && self.fabric.articleId !== undefined && self.fabric.articleId !== '')
      saveFabric(fabric, existingFabric)
        .then(function(response) {
          self.$toast.open({
            message: 'Fabric was saved successfully.',
            duration: 5000,
            position: 'is-bottom',
            type: 'is-success'
          })
          self.getFabric()
        })
        .catch(function(error) {
          console.log(error)
          self.$toast.open({
            message: 'Failed to save fabric in database.',
            duration: 5000,
            position: 'is-bottom',
            type: 'is-danger'
          })
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.field .label .label-description {
  font-size: 0.75rem;
  font-style: italic;
  font-weight: normal;
}
.field .label .required-field{
  color: red;
  font-weight: bold;
}
section {
  padding: 0.5rem 0rem;
}
.followup {
  margin-left: 2rem;
}
hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.content {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Fabric.vue